import { ATTACHMENT_MAX_COUNT, attachmentMediaType, fileToAttachment, previewMediaType } from './fileMedia.js';
// Match gyro-svc/src/attachments.ts. The wire limits count base64 characters, not raw file bytes.
export const ATTACHMENT_MAX_BASE64 = 6_800_000;
export const ATTACHMENT_TOTAL_BASE64 = 20_000_000;
const FILE_LIMIT_ERROR = 'over the 5.1 MB upload limit';
const TOTAL_LIMIT_ERROR = 'over the combined 15 MB attachment limit';
/**
 * Prepare one bounded batch without changing the draft. The caller serializes batches, supplies its
 * latest attachments, and checks its draft/identity epoch before committing the returned new files.
 * This function deliberately has no commit callback: cancelling a draft can never commit from here.
 */
export async function prepareAttachments(files, existing, options = {}) {
    const accepted = [];
    const errors = [];
    const room = Math.max(0, ATTACHMENT_MAX_COUNT - existing.length);
    let total = existing.reduce((sum, attachment) => sum + attachment.data.length, 0);
    if (files.length > room)
        errors.push(`Maximum ${ATTACHMENT_MAX_COUNT} attachments; extra files were skipped.`);
    // Do not read excess files only to throw their buffers away. Failed candidates can be retried in a
    // later batch; they do not silently cause extra candidates beyond the admitted batch to be read.
    for (const file of files.slice(0, room)) {
        try {
            const mediaType = attachmentMediaType(file); // reject unsupported, empty, and oversized files before any read
            if (options.fileAttachments === false && !previewMediaType(mediaType))
                throw new Error('This Gyro service needs an update before it can read Office, text, and archive attachments.');
            const estimatedBase64 = Math.ceil(file.size / 3) * 4;
            if (estimatedBase64 > ATTACHMENT_MAX_BASE64)
                throw new Error(FILE_LIMIT_ERROR);
            if (total + estimatedBase64 > ATTACHMENT_TOTAL_BASE64)
                throw new Error(TOTAL_LIMIT_ERROR);
            const attachment = await fileToAttachment(file);
            // Check the encoded payload too; only the actual payload determines what the service accepts.
            if (attachment.data.length > ATTACHMENT_MAX_BASE64)
                throw new Error(FILE_LIMIT_ERROR);
            if (total + attachment.data.length > ATTACHMENT_TOTAL_BASE64)
                throw new Error(TOTAL_LIMIT_ERROR);
            total += attachment.data.length;
            accepted.push(attachment);
        }
        catch (error) {
            errors.push(`${file.name || 'File'}: ${error instanceof Error ? error.message : 'could not read file'}`);
        }
    }
    return { accepted, errors };
}
//# sourceMappingURL=attachmentIntake.js.map